import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import * as FileService from 'services/file/file';

export const useFileService = () => {
  const { token } = useSelector((store) => store.user_data);

  const uploadDocument = async (options = {}) => {
    const { error, payload } = await FileService.uploadDocument({
      ...options,
      token,
      headers: {
        ...(options.headers || {}),
        'Content-Type': 'application/form-data'
      }
    });

    if (error) {
      toast.error(error);
      return null;
    }

    return payload;
  };

  const uploadImage = async (options = {}) => {
    const { error, payload } = await FileService.uploadImage({
      ...options,
      token,
      headers: {
        ...(options.headers || {}),
        'Content-Type': 'application/form-data'
      }
    });

    if (error) {
      toast.error(error);
      return null;
    }

    return payload;
  };

  return { uploadDocument, uploadImage };
};
